import { Link } from '@mui/material'

interface Props {
  children: string | undefined
}

export default function FedExTrackingNumber({ children }: Props) {
  return (
    <Link
      onClick={() => {
        if (children) {
          window.open(`https://fedex.com/wtrk/track/?trknbr=${children}`, '_blank')
        }
      }}
      sx={{ cursor: 'pointer' }}
    >
      {children}
    </Link>
  )
}
